import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AUTO_HEIGHT_SHEET_BREAKPOINTS, SHEET_FULL_CONTENT_BREAKPOINT } from 'src/app/utils/auto-height-sheet';

/** Alto con el que abría siempre este modal; lo conservan los consumidores sin autoHeight. */
const LEGACY_INITIAL_BREAKPOINT = 0.95;
/** Copia propia y estable: un array nuevo en cada detección de cambios re-seteaba el ion-modal. */
const AUTO_HEIGHT_BREAKPOINTS: number[] = [...AUTO_HEIGHT_SHEET_BREAKPOINTS];

@Component({
  selector: 'app-dynamic-filter-modal',
  templateUrl: './dynamic-filter-modal.component.html',
  styleUrls: ['./dynamic-filter-modal.component.scss'],
  standalone: false
})
export class DynamicFilterModalComponent {

  @Input() isOpen: boolean = false;
  /**
   * Título del sheet. Con título, el encabezado es "Título + ✕ de 44px"; sin él
   * queda el encabezado anterior ("CERRAR FILTROS") para quien no migró todavía.
   */
  @Input() titleKey: string | null = null;
  /** Sube solo lo que mide el contenido (decisión global #10). */
  @Input() autoHeight = false;

  get breakpoints(): number[] | undefined {
    return this.autoHeight ? AUTO_HEIGHT_BREAKPOINTS : undefined;
  }

  get initialBreakpoint(): number {
    return this.autoHeight ? SHEET_FULL_CONTENT_BREAKPOINT : LEGACY_INITIAL_BREAKPOINT;
  }
  // TODO(migracion-ng21): renombrar a 'closed'. 'close' colisiona con un evento
  // nativo del DOM. Regla detectada al subir a angular-eslint 19; el codigo es
  // previo a la migracion. El rename cambia la API de un componente compartido
  // usado en 2 templates, asi que queda fuera del alcance del bump de version.
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

}
